import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_REGION_BY_ID = 'GET_REGION_BY_ID';
export const GET_REGION_BY_ID_SUCCESS = 'GET_REGION_BY_ID_SUCCESS';
export const GET_REGION_BY_ID_FAIL = 'GET_REGION_BY_ID_FAIL';
export const GET_REGION_BY_ID_RESET = 'GET_REGION_BY_ID_RESET';

export const getRegionById = (params) => {
	return {
		type: GET_REGION_BY_ID,
		params,
	};
};

export const getRegionByIdSuccess = (response) => {
	return {
		type: GET_REGION_BY_ID_SUCCESS,
		response,
	};
};

export const getRegionByIdFail = (response) => {
	return {
		type: GET_REGION_BY_ID_FAIL,
		response,
	};
};

export const getRegionByIdReset = () => {
	return {
		type: GET_REGION_BY_ID_RESET,
	};
};

export const getRegionByIdApi = (data) => {
	return (dispatch) => {
		dispatch(getRegionById());
		axios
			.get(`${config.api.base_url}/regions/${data.id}`, {
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getRegionByIdData = response.data;
				dispatch(getRegionByIdSuccess(getRegionByIdData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getRegionByIdFail(errorMsg));
			});
	};
};
